import Joi from '@hapi/joi'

export const productSchemaObject = {
    productCode: Joi.string().required().label("Product Code").regex(/^(?!\s*$).+/).messages({
        "string.empty": `Product Code required`,
        "string.pattern.base": `Product Code cannot have invalid characters`,
        "string.min": `Please enter {#limit} digit number`,
        "string.max": `Please enter {#limit} digit number`,
        "any.invalid": `Cannot have 00 as Product code`
    }),
    productName: Joi.string().required().label("Product Name").regex(/^(?!\s*$).+/).messages({
        "string.empty": `Product Name required`,
        "string.pattern.base": `Please enter valid Product Name`,
    }),
    productDescription: Joi.string().required().label("Product Description").regex(/^(?!\s*$).+/).messages({
        "string.empty": `Product Description required`,
        "string.pattern.base": `Please enter valid Product Description`,
    }),
    isActive: Joi.boolean().label("Active")
}